import { SvgIconProps } from '@mui/material';
import CertificateIcon from './Icons/CertificateIcon';
import GroupIcon from './Icons/GroupIcon';
import PeoplePlus from './Icons/PeoplePlus';
import LocationIcon from './Icons/LocationIcon';
import CubesIcon from './Icons/CubesIcon';
import PLetter from './Icons/PLetter';
import RLetter from './Icons/RLetter';
import Replacement from './Icons/Replacement';
import OutlinedCalendarIcon from './Icons/OutlinedCalendarIcon';
import OutlinedEnglishIcon from './Icons/OutlinedEnglishIcon';
import EnglishIcon from './Icons/EnglishIcon';
import SalaryIcon from './Icons/SalaryIcon';
import SUserIcon from './Icons/SUserIcon';
import RUserIcon from './Icons/RUserIcon';
import CSUserIcon from './Icons/CSUserIcon';
import CalendarIcon from './Icons/СalendarIcon';
import BaselinePeopleIcon from './Icons/BaseLinePeopleIcon';
import WorkIcon from './Icons/WorkIcon';
import NoteIcon from './Icons/NoteIcon';
import TechnologyIcon from './Icons/TechnologyIcon';
import SpecializationIcon from './Icons/SpecializationLevelIcon';
import SpecializationLevelIcon from './Icons/SpecializationIcon';
import VerifiedDocumentIcon from './Icons/VerifiedDocumentIcon';
import RejectedDocumentIcon from './Icons/RejectedDocumentIcon';
import CompletedCheckIcon from './Icons/CompletedCheckIcon';
import TelegramColorIcon from './Icons/TelegramColorIcon';
import ThreeDotsIcon from './Icons/ThreeDotsIcon';

export type AppIconType =
  | 'completed-check'
  | 'telegram-color'
  | 'english'
  | 'salary'
  | 'r-user'
  | 's-user'
  | 'cs-user'
  | 'calendar'
  | 'baseline-people'
  | 'work'
  | 'note'
  | 'technology'
  | 'specialization'
  | 'competencyLevel'
  | 'certificate'
  | 'group'
  | 'peoplePlus'
  | 'location'
  | 'cubes'
  | 'pLetter'
  | 'rLetter'
  | 'replacement'
  | 'outlinedCalendar'
  | 'outlinedEnglish'
  | 'verified-document'
  | 'rejected-document'
  | 'three-dots';
export const AppIconTypeToSvgIcon: Record<AppIconType, React.FC<SvgIconProps>> = {
  english: EnglishIcon,
  salary: SalaryIcon,
  'r-user': RUserIcon,
  's-user': SUserIcon,
  'cs-user': CSUserIcon,
  calendar: CalendarIcon,
  'baseline-people': BaselinePeopleIcon,
  work: WorkIcon,
  note: NoteIcon,
  technology: TechnologyIcon,
  specialization: SpecializationIcon,
  competencyLevel: SpecializationLevelIcon,
  certificate: CertificateIcon,
  group: GroupIcon,
  peoplePlus: PeoplePlus,
  location: LocationIcon,
  cubes: CubesIcon,
  pLetter: PLetter,
  rLetter: RLetter,
  'three-dots': ThreeDotsIcon,
  replacement: Replacement,
  outlinedCalendar: OutlinedCalendarIcon,
  outlinedEnglish: OutlinedEnglishIcon,
  'verified-document': VerifiedDocumentIcon,
  'rejected-document': RejectedDocumentIcon,
  'completed-check': CompletedCheckIcon,
  'telegram-color': TelegramColorIcon,
};
